import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoPersona, TipoPersonaProps } from '../../interfaces/catalogos/TipoPersonaInterface';

export const TipoPersona = () => {

    return new Promise<TipoPersonaProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoPersona/', token)
            .then( ({ data } : { data : TipoPersonaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoPersona = () => {

    return new Promise<TipoPersonaProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoPersona/ObtenerTipoPersona', token)
            .then( ({ data } : { data : TipoPersonaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoPersona = ( params: TipoPersonaProps ) => {

    return new Promise<TipoPersonaProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoPersona/Actualizar', params, token)
            .then( ({ data } : { data : TipoPersonaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoPersona } );
            });

        }

    });

}

export const AgregarTipoPersona = ( params: TipoPersonaProps ) => {

    return new Promise<TipoPersonaProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoPersona/Agregar', params, token)
            .then( ({ data } : { data : TipoPersonaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoPersona } );
            });

        }

    });

}
